import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonRo from './locales/ro/common.json';
import commonEn from './locales/en/common.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ro: { common: commonRo },
      en: { common: commonEn }
    },
    lng: 'ro',           // limba implicită
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false }
  });

export default i18n;